// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs_breadcrumbs__3zOH5","breadcrumbItem":"Breadcrumbs_breadcrumbItem__1f-0S"};